var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},[_c('article',{staticClass:"media"},[_c('div',{staticClass:"media-content"},[_c('div',{staticClass:"has-text-centered",style:(`width:${_vm.width}; height:322px;`),attrs:{"id":_vm.chartId}}),_c('div',{staticClass:"has-text-centered"},[_c('h5',[_c('b',[_vm._v(_vm._s(this.title))])])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }